import React, { useCallback, useEffect, useRef, useState } from 'react'
import { NativeBaseProvider, Text, Image, View, Progress, useMediaQuery } from 'native-base'
import { Linking, ActivityIndicator, Alert, BackHandler, ScrollView, StatusBar, StyleSheet, TouchableHighlight, TouchableOpacity, Animated, Platform } from 'react-native'

import Colors from '../constants/Colors';
import Swiper from 'react-native-swiper/src'
import { MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import { getApp, getCount, getInitOrder, getProfileinfo, getSlider, logOut, sendtokenPush } from '../store/action/userLogin';
import { useDispatch, useSelector } from 'react-redux';
import { useFocusEffect, useIsFocused } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AwesomeAlert from 'react-native-awesome-alerts';
import NetInfo from "@react-native-community/netinfo";
 










function Home(props) {


    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();


    const [Slider, setslider] = useState([]);
    const [APP, setAPP] = useState([])
    const [Message, setMessage] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [isLoading1, setLoading1] = useState(false);
    const [Info, setInfo] = useState("");

    const [Wallet, setWallet] = useState(false)
    const [Wallet1, setWallet1] = useState(false)
    const [ERROR, setError] = useState(false);
    const [ERROR1, setError1] = useState(false);





    const getCountHandler = async () => {
        try {
            setLoading1(true)
            const res = await dispatch(getCount(tokens));
            //   console.log("hhhhhh",res.data.data.status);


            if (res.data.data.status == "false") {

                props.navigation.navigate("mdfwhite");

            } else {
                setError1(true)
            }
            // setslider(res.data.data.sliders);
            setLoading1(false);


        } catch (err) {


            // logOutHandler()
        }
    };











    const getSliderHandler = async () => {
        try {
            setLoading(true)
            const res = await dispatch(getSlider(tokens));
            //console.log(res.data.data.sliders);
            setslider(res.data.data.sliders);
            setLoading(false);


        } catch (err) {


            //  logOutHandler()
        }
    };



    const getAPPHandler = async () => {
        try {

            const res = await dispatch(getApp(tokens));

            setAPP(res.data.data.apps)

            //  console.log(res.data.data);

        } catch (err) {
            //  logOutHandler()
        }
    };



    //پروفایل 
    const getprofileHandler = async () => {
        try {

            const res = await dispatch(getProfileinfo(tokens));
            //  console.log(res.data.data.exp_payment);
            if (res.data.data.exp_payment == "true") {
                setInfo(res.data.data.user)
                setMessage(res.data.data)
                setWallet(res.data.data.version)
                setTimeout(() => {
                    if (res.data.data !== null) {
                 if (res.data.data.version.status == "true") {
                     if (res.data.data.version.version !== "1") {
                         setError(true)
                     }
                 }
             }

             }, 1000);
            }



        } catch (err) {

            // logOutHandler()
        }
    };


    useFocusEffect(useCallback(()=> {
        async function handler() {
            console.log('token' , tokens);


            const expo_token = await AsyncStorage.getItem('expo_token');

            console.log('expo token --- test =>' ,expo_token);

            if (expo_token) {
                const res = await dispatch(sendtokenPush(tokens , expo_token));

                console.log('expo token res' , res);
            }

        }

        handler();
    }, []));











    useEffect(() => {
        getAPPHandler();
        getSliderHandler();

       


    }, [])


    const isfocuce = useIsFocused();
    useEffect(() => {
        getprofileHandler()
    
        if (!tokens) {
            logOutHandler()
        }
        unsubscribe()

    }, [isfocuce])



    const logOutHandler = async () => {
        try {

            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    useFocusEffect(
        React.useCallback(() => {



            const backAction = () => {
                Alert.alert("هشدار!", "میخواهید  برنامه را ببندید ؟", [
                    { text: "بازگشت" },
                    { text: "بله", onPress: () => BackHandler.exitApp() }
                ]);
                return true;
            };
            const backHandler = BackHandler.addEventListener(
                "hardwareBackPress",
                backAction
            );

            return () => backHandler.remove();
        }, [])
    );






    const fadeAnim = useRef(new Animated.Value(0)).current;
    const fadeIn = () => {
        // Will change fadeAnim value to 1 in 5 seconds
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true
        }).start();
    };

    const fadeOut = () => {
        // Will change fadeAnim value to 0 in 3 seconds
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 500,
            useNativeDriver: true
        }).start();
    };




    if (Message.has_message == "has_message" || Message.has_ticket == "has_ticket") {
        setTimeout(() => {
            setWallet1(!Wallet1)
            if (Wallet1 == true) {
                fadeIn()
            } else {
                fadeOut()
            }
        }, 1200);
    }




    const handleOpenWithLinking = (url) => {
        Linking.openURL(url);
    };


    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500,


    });



    function unsubscribe() {
        NetInfo.fetch().then(state => {

            //   setNetwork(state)


            if (state.isConnected == false) {
                //  props.navigation.navigate("splash")
                Alert.alert("هشدار!", "لطفا اتصال اینترنت خود را بررسی کنید", [

                    { text: "باشه", onPress: () => unsubscribe() }
                ]);
                // any thing you want to load before navigate home screen
            }

        })
    };














    return (



        <NativeBaseProvider  >


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                marginLeft: isSmallScreen ? 0 : "35%",

                height: "100%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative",

            }}>



                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />



                    {Message.has_message == "has_message" ?
                        <TouchableOpacity style={styles.menu2} onPress={() => props.navigation.navigate("orderlist", {
                            refresh: "true"
                        })}  >
                            <Animated.View style={{ opacity: fadeAnim }}  >
                                <MaterialCommunityIcons name={"bell-ring"} size={30} color={Colors.greenalarm} />
                            </Animated.View>
                            <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.background }}>پیام در سفارشات</Text>
                        </TouchableOpacity>
                        :
                        <View></View>}

                    {Message.has_ticket == "has_ticket" ?
                        <TouchableOpacity onPress={() => props.navigation.navigate("ticket")} style={styles.menu}>
                            <Animated.View style={{ opacity: fadeAnim }}   >
                                <MaterialCommunityIcons name={"bell-ring"} size={30} color={Colors.greenalarm} />
                            </Animated.View>
                            <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.background }}>پیام در پشتیبانی</Text>
                        </TouchableOpacity>
                        :
                        <View></View>}

                    <TouchableOpacity style={styles.menu1} onPress={() => props.navigation.navigate("ticket")}  >
                        <MaterialCommunityIcons name={"face-agent"} size={30} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>پشتیبانی</Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.menu3} onPress={() => props.navigation.navigate("splash")}  >
                        <MaterialCommunityIcons name={"reload"} size={30} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>بارگزاری مجدد</Text>
                    </TouchableOpacity>

                </View>




                <ScrollView style={{ backgroundColor: "white", alignSelf: "auto", marginBottom: 60 }} >



                    <View style={{ width: "100%", height: 300, padding: 10 }}>



                        {isLoading ?
                            <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                                <ActivityIndicator
                                    animating={isLoading} size={30} color={Colors.primary} />


                            </View>
                            :

                            <Swiper



                                paginationStyle={{
                                    bottom: 0,
                                    left: 0
                                }}

                                autoplay={true}

                                loop
                                key={Slider.length}


                                dot={
                                    <View style={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: 4,
                                        margin: 5,
                                        backgroundColor: Colors.secondText
                                    }} />
                                }
                                activeDot={
                                    <View style={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: 6,
                                        margin: 5,
                                        backgroundColor: "red"
                                    }} />
                                }
                            >




                                {Slider.map((index, i) => {
                                    return (
                                        <View style={{ flex: 1 }} key={i}

                                        // onPress={() => {

                                        //         props.navigation.navigate("web", {
                                        //             addressweb: index.link
                                        //         })

                                        // }}
                                        >



                                            <Image
                                                source={{ uri: "https://npln.ir" + index.images[1].address }} alt={index.images[1].type}
                                                style={{ height: 300, width: "100%" }} resizeMode="stretch"
                                            />
                                        </View>
                                    )

                                })}


                            </Swiper>
                        }
                    </View>





                    <TouchableOpacity onPress={() => getCountHandler()} style={{ width: "95%", height: 70, backgroundColor: Colors.primary, marginLeft: 10, flexDirection: "row", alignItems: "center" }}>
                        <Image source={require("../../assets/icons.png")} alt="image" style={{ width: "28%", height: "95%", borderRadius: 10, right: "3%", position: "absolute" }} />

                        {isLoading1 == false ?
                            <Text style={{ fontFamily: "MontserratBold", fontSize: 16, color: Colors.background, left: "5%", position: "absolute", marginRight: "5%" }}>سفارش جدید طراحی</Text>
                            :
                            <ActivityIndicator
                                animating={isLoading1} size={30} color={Colors.background} style={{ left: 90 }} />
                        }
                    </TouchableOpacity>



                    <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-end", width: "100%", marginTop: 20 }}>

                        {APP.map((index, i) => {
                            return (
                                <TouchableOpacity key={i} onPress={() => {

                                    props.navigation.navigate("web", {
                                        addressweb: index.link
                                    })



                                }} style={{ marginRight: "1%", width: "32%", height: 110, alignItems: "center", justifyContent: "center", marginTop: 5 }}>
                                    <Image source={{ uri: "https://npln.ir" + index.images[1].address }} alt={index.images[1].type} style={{ width: "70%", height: "70%", borderRadius: 10 }} />
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.black, padding: "5%" }}>
                                        {index.name}
                                    </Text>

                                </TouchableOpacity>
                            )
                        })}




                    </View>


                    <View style={{ width: "100%", height: 20, }}></View>
                </ScrollView>

           



                <AwesomeAlert
                    show={ERROR1}
                    showProgress={false}
                    title={"هشدار !"}
                    message={"شما سفارش فعال دارید کدام مرحله را انتخاب میکنید"}
                    closeOnTouchOutside={true}
                    closeOnHardwareBackPress={true}
                    showCancelButton={true}
                    showConfirmButton={true}
                    cancelText="سفارش جدید"
                    confirmText="سفارشات فعال"
                    
                    confirmButtonColor={Colors.success}
                    onCancelPressed={() => {
                        props.navigation.navigate("mdfwhite");   
                        setError1(false)
                    }}
                    onConfirmPressed={() => {
                        props.navigation.navigate("orderlist", {
                            refresh: "true"
                        })
                        setError1(false)
                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                    confirmButtonStyle={{ width: "45%", height: 40, alignItems: "center" }}
                    cancelButtonStyle={{ width: "53%", height: 40, backgroundColor: Colors.primary, alignItems: "center" }}
                    cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                /> 







                <AwesomeAlert
                    show={ERROR}
                    showProgress={false}
                    title={"هشدار !"}
                    message={"نسخه شما قدیمی است لطفا نسخه جدید را نصب کنید. "}
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    showCancelButton={Wallet.force == "true" ? false : true}
                    showConfirmButton={true}
                    cancelText="بعدا"
                    confirmText="نصب کردن"
                    confirmButtonColor={Colors.success}
                    onCancelPressed={() => {
                        setError(false)
                    }}
                    onConfirmPressed={() => {
                        handleOpenWithLinking("https://npln.ir")
                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                    confirmButtonStyle={{ width: "45%", height: 40, alignItems: "center" }}
                    cancelButtonStyle={{ width: "53%", height: 40, backgroundColor: Colors.primary, alignItems: "center" }}
                    cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                />


                <View style={{
                    flexDirection: "row",
                    width: isSmallScreen ? "100%" : 500,
                    height: 60,
                    backgroundColor: Colors.primary,
                    position: Platform.OS === "web" ? "fixed" : "absolute",
                    bottom: 0
                }}>
                    <TouchableOpacity onPress={() => props.navigation.navigate("orderlist", {
                        refresh: "true"
                    })} style={{ width: "15%", height: 60, position: "absolute", right: "5%", alignItems: "center", padding: 5 }}>
                        <Ionicons name="reader-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            سفارشات
                        </Text>
                    </TouchableOpacity>






                    <TouchableOpacity onPress={() => props.navigation.navigate("profile")} style={{ width: "15%", height: 60, alignItems: "center", left: 15, top: 5 }}>
                        <MaterialCommunityIcons name="badge-account-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            پروفایل
                        </Text>
                    </TouchableOpacity>









                    <View style={{ width: "30%", height: 60, left: "35%", alignItems: "center", flexDirection: "column", position: "absolute" }}>

                        <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: Colors.yellowlight, borderWidth: 5, borderColor: Colors.background, bottom: 28, alignItems: "center", justifyContent: "center" }}>
                            <Ionicons name="home-outline" size={20} color={Colors.background} />
                        </View>

                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.yellow, position: 'absolute', bottom: 15 }}>
                            صفحه اصلی
                        </Text>
                        <View style={{ width: 30, height: 5, borderRadius: 5, backgroundColor: Colors.yellowlight, position: 'absolute', bottom: 5 }}></View>
                    </View>


                </View>

            </View>
        </NativeBaseProvider>

    )




};
const styles = StyleSheet.create({

    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        alignItems: 'center',
        justifyContent: "center"
    },
    viewfooter: {
        flexDirection: "row",
        width: Platform.OS == "web" ? "400px" : "100%",
        height: 60,
        backgroundColor: Colors.primary,
        position: Platform.OS === "web" ? "fixed" : "absolute",
        bottom: 0


    },
    menu1: {
        backgroundColor: Colors.primary,
        width: 50,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "39%",
    },
    menu3: {
        backgroundColor: Colors.primary,
        width: 80,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: 15,
        top: Platform.OS == "web" ? "15%" : "39%",
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 80,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: "60%",
        top: Platform.OS == "web" ? "0%" : "28%",
    },
    menu2: {
        backgroundColor: Colors.primary,
        width: 80,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: "35%",
        top: Platform.OS == "web" ? "0%" : "28%"
    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 130,
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute", left: 3,
        top: "25%"
    },


})


export default Home;







